import React, { useEffect, useState } from 'react';
import { Typography, Card, Box } from '@mui/material';
import '../LeaveStatusComponent.css';
import { getLeaveTypeList } from '../../../../services/LeaveService';
import { isQuarterlyCasualAccounting } from '../../../../utils/casualLeaveUtils';
import { getCurrentQuarterCasualStats } from '../../../../services/CasualLeaveAccountingService';

const LeaveCardComponent = (props) => {
  const { leave, accountingSnapshot } = props;
  const [leaveTypeName, setLeaveTypeName] = useState('');
  const [leaveCategory, setLeaveCategory] = useState(1);

  useEffect(() => {
    loadLeaveType();
  }, []);

  const loadLeaveType = async () => {
    const year = new Date().getFullYear();
    const leaveList = await getLeaveTypeList(year);
    const leaveTypeName = leaveList.data.find(
      (item) => item.id === leave.leaveId,
    )?.leaveName;
    setLeaveTypeName(leaveTypeName);
    const leaveCategoryId = leaveList.data.find(
      (item) => item.id === leave.leaveId,
    ).leaveCategoryId;
    setLeaveCategory(leaveCategoryId);
  };

  if (leaveCategory === 2) return null;

  const hasQuarterlyAccounting = isQuarterlyCasualAccounting(leave);
  const casualStats = getCurrentQuarterCasualStats(accountingSnapshot);

  const renderEntitledAvailed = (entitled, availed, entitledLabel, availedLabel) => (
    <>
      <div className="leave-stat-container">
        <div className="leave-number available-leave">
          <Typography align="center" variant="h6" component="div">
            {entitled}
          </Typography>
        </div>
        <div className="leave-stats">{entitledLabel}</div>
      </div>
      <div className="leave-stat-container">
        <div className="leave-number used-leave">
          <Typography align="center" variant="h6" component="div">
            {availed}
          </Typography>
        </div>
        <div className="leave-stats">{availedLabel}</div>
      </div>
    </>
  );

  let body;
  if (hasQuarterlyAccounting && accountingSnapshot && casualStats) {
    const quarterLabel = casualStats.quarter
      ? `Q${casualStats.quarter}`
      : 'Quarterly';
    body = renderEntitledAvailed(
      casualStats.entitled,
      casualStats.availed,
      `${quarterLabel} Entitled`,
      `${quarterLabel} Availed`,
    );
  } else if (hasQuarterlyAccounting) {
    const quarterLabel = leave.quarter ? `Q${leave.quarter}` : 'Quarterly';
    body = renderEntitledAvailed(
      leave.quarterlyAllocatedDays ?? 0,
      leave.quarterlyUsedDays ?? 0,
      `${quarterLabel} Entitled`,
      `${quarterLabel} Availed`,
    );
  } else {
    body = renderEntitledAvailed(
      leave.totalAllowedLeaves ?? 0,
      !leave.usedLeaves ? 0 : leave.usedLeaves,
      'Entitled Leaves',
      'Availed Leaves',
    );
  }

  return (
    <Card variant="outlined" className="leave-card" sx={{ mb: 2, p: 1 }}>
      <div className="leave-stat-header" style={{ textAlign: 'center' }}>
        <strong>{leaveTypeName}</strong>
      </div>
      {body}
    </Card>
  );
};

export default LeaveCardComponent;
